namespace GeniuzPOS.Member {
    export class PsMemberGenderColumns {
        static columnsKey = 'Member.PsMemberGender';
    }
}
